<script setup lang="ts">
import { ref, watchEffect, watch } from 'vue';
import { IPrintTemplate, GetManyResult } from '@posx/core';
import { usePrinterStore } from '@/stores/printer';
import { logError, serializeError } from '@/utils/logger';

const $emit = defineEmits<{
  (event: 'change', value: string): void;
  (event: 'update', value: string): void;
  (event: 'update:modelValue', value: string): void;
}>();
const $props = defineProps<{
  modelValue: string;
  type?: string;
  rootFormData?: any;
}>();

const currentValue = ref<string>($props.modelValue);
const printerStore = usePrinterStore();
const printerList = ref<IPrintTemplate[]>([]);

const handleChange = () => {
  $emit('change', currentValue.value);
  $emit('update:modelValue', currentValue.value);
};

watchEffect(() => {
  printerStore
    .getTemplateList({
      printer_type: $props.rootFormData?.type,
    })
    .then((value?: GetManyResult<IPrintTemplate>) => {
      // Exclude report templates so they cannot be bound to a printer
      if (value?.list) printerList.value = value.list.filter((t) => !t.report_code_name);
    }).catch((err) => logError('Failed to fetch printer templates', serializeError(err)));
});
</script>

<template>
  <el-select v-model="currentValue" @change="handleChange">
    <el-option :label="value.name" :value="value.uid" v-for="(value, key) in printerList" />
  </el-select>
</template>
